module.exports = __webpack_public_path__ + "static/media/7847A88A-EE27-46D0-9E2C-D107FA563D60.97e2cce6.jpeg";